import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button,
  Card, CardBody, CardContent,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import isEmpty from 'lodash/isEmpty';
import { ResponsiveCardActions, AddMobileSpacing } from './styles';
import { fetchStoresData, trackAnalytics } from '../ProjectLocation/helpers';
import { storeType } from '../ProjectLocation/types';
import ZipCodeInput from '../inputZipcode';
import { analyticConstants } from '../../utils/constants';

const StoreLocalizationModal = ({
  handleUpdateStore,
  isMobile,
  onCloseModal,
  showModal,
  setLocalZipCode,
  setShowEditStoreLocation,
  stores,
  zipcode
}) => {
  const [modalZipCode, setModalZipCode] = useState(zipcode);
  const { storeNumber } = useSelector((state) => state.store);
  const [storeApiInfo, setStoreApiInfo] = useState({});
  const [storesForUI, setStoresForUI] = useState(stores || []);
  const { fetchStores, viewMoreClick } = analyticConstants;

  const onStoreUpdate = (storeId) => {
    handleUpdateStore(storeApiInfo.stores, storeId, viewMoreClick);
    setShowEditStoreLocation(false);
    setLocalZipCode(modalZipCode.length === 5 ? modalZipCode : zipcode);
    onCloseModal();
  };

  const handleZipCodeUpdate = async (zip) => {
    trackAnalytics(fetchStores, viewMoreClick);
    const data = await fetchStoresData(zip, storeNumber);
    setStoreApiInfo(data);
  };

  useEffect(() => {
    if (!isEmpty(storeApiInfo.stores)) {
      setStoresForUI(storeApiInfo.stores);
    }
  }, [storeApiInfo]);

  return (
    <Modal open={showModal} onClose={onCloseModal} size={isMobile ? 'lg' : 'md'}>
      <ModalHeader onClose={onCloseModal}>
        <Typography variant="h4" style={{ marginBottom: '1.6rem' }}>Change Your Local Store</Typography>
        <Typography paragraph>Enter your ZIP Code to view more stores near you.</Typography>
        <ZipCodeInput
          zipcode={modalZipCode}
          onUpdateCallback={handleZipCodeUpdate}
          onZipcodeChange={setModalZipCode}
        />
      </ModalHeader>
      <ModalBody>
        {(
          storesForUI.map((store) => {
            const { name, phone, storeId } = store;
            const { street, state, postalCode } = store.address;
            const storeNameAndId = `${name} #${storeId}`;
            const storeAddress = `${street}, ${state} ${postalCode}`;
            const storePhone = `Phone: ${phone}`;
            return (
              <Card id="card__card" grow style={{ marginBottom: '1.6rem' }}>
                <CardContent orientation="horizontal" disablePadding disableGutters>
                  <CardBody>
                    <Typography lineClamp="1" variant="h3">{storeNameAndId}</Typography>
                    <Typography
                      lineClamp={{ default: '2', lg: '1' }}
                      paragraph
                      color="subtle"
                    >
                      {storeAddress}
                    </Typography>
                    <Typography lineClamp="1" paragraph color="subtle">{storePhone}</Typography>
                    <AddMobileSpacing />
                  </CardBody>
                  <ResponsiveCardActions>
                    <Button
                      fullWidth
                      variant="secondary"
                      onClick={() => onStoreUpdate(store.storeId)}
                    >
                      Shop This Store
                    </Button>
                  </ResponsiveCardActions>
                </CardContent>
              </Card>
            );
          })
        )}

      </ModalBody>
      <ModalFooter>
        <Button fullWidth href={`https://www.homedepot.com/l/search/${storeNumber}`}>View More Stores</Button>
      </ModalFooter>
    </Modal>
  );

};

StoreLocalizationModal.propTypes = {
  handleUpdateStore: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  setLocalZipCode: PropTypes.func.isRequired,
  setShowEditStoreLocation: PropTypes.func.isRequired,
  showModal: PropTypes.bool,
  stores: PropTypes.arrayOf(storeType).isRequired,
  zipcode: PropTypes.string.isRequired,
};
StoreLocalizationModal.defaultProps = {
  showModal: false,
};

export default StoreLocalizationModal;